// extracted by mini-css-extract-plugin
export default {"firms":"Firms_firms__ASqEM","container":"Firms_container__0nsi-"};